import { DebouncedTextInput } from "ra-friendsofbabba";
import React, { useMemo, useEffect } from "react";
import { useForm, useFormState } from "react-final-form";
import { get } from "lodash";

const DocFileTypeOtherInput = (props) => {
  const { values } = useFormState({ subscription: { values: true } });
  const form = useForm();
  const isOther = useMemo(
    () => (get(values, "doc_file_type_id", null) === 3 ? true : false),
    [values]
  );

  useEffect(() => {
    if (!isOther) {
      form.change("doc_file_type_other", null);
    }
  }, [isOther, form]);

  if (!isOther) {
    return null;
  }
  return (
    <DebouncedTextInput
      {...props}
      source="doc_file_type_other"
      maxLength={100}
    />
  );
};
export default DocFileTypeOtherInput;
